const authorizationHeader = (token?: string): { Authorization: string } => {
  const bearer = token || localStorage.getItem("access-token");

  return {
    Authorization: `Bearer ${bearer}`,
  };
};

export { authorizationHeader };
